import application from 'application/application';

application

	.directive('ngStopPropagation', () => ({
		restrict: 'A',
		scope: {
			ngPreventDefault: '='
		},
		link(scope, element, attrs) {

			$(element).on(attrs.ngStopPropagation, event => {

				event.stopPropagation();

				if (scope.ngPreventDefault)

					event.preventDefault();

			});

		}
	}));
